import React, { useEffect, useState } from "react";

// ASSETS

// STYLES

// LIBRARIES
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { CenterWrapper, Circle, SliderWrapper } from "./AlertsCarouselStyled";
import { useTranslation } from "react-i18next";

// MISC
import useWindowWidth from "hooks/useWindowWidth";
import { ConsultationResponse, SliderProps } from "./AlertsCarouselModel";

// REDUX

// COMPONENTS
import AlertsCarouselItem from "components/AlertsCarouselItem/AlertsCarouselItem";
import homeService from "services/homeService";

const CarouselSlider: React.FC<SliderProps> = () => {
  // PROPERTIES

  // LIBRARY CONSTANTS
  const { t } = useTranslation();

  // STATE CONSTANTS
  const [currentSlide, setCurrentSlide] = useState(0);
  const windowWidth = useWindowWidth();
  const [alerts, setAlerts] = useState<ConsultationResponse>();
  const slidesToShow = windowWidth >= 1300 ? 3 : windowWidth >= 900 ? 2 : 1;
  // API REQUESTS

  // LIFE CYCLE
  useEffect(() => {
    // setLoading(true);
    homeService
      .getNewsArticles(true)
      .then((data) => {
        // console.log("getNewsArticles response", data);
        setAlerts(data);
        // setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        // setLoading(false);
      });
  }, []);

  // EVENT HANDLERS
  const settings = {
    customPaging: function (i) {
      return (
        <button type="button" aria-label={t("components.carouselSlider.goToAlert", { number: i + 1 })}
          aria-current={i === currentSlide ? "true" : undefined}>
          <Circle $active={i === currentSlide} aria-hidden="true" />
        </button>
      );
    },
    dots: (alerts?.data?.length ?? 0) > slidesToShow,
    arrows: false,
    infinite: (alerts?.data?.length ?? 0) > slidesToShow,
    speed: 500,
    slidesToShow: Math.min(slidesToShow, alerts?.data?.length || 1),
    slidesToScroll: 1,
    afterChange: (current) => {
      setCurrentSlide(current);
    },
  };

  if (!alerts?.data?.length) return null;

  return (
    <SliderWrapper aria-label={t("components.carouselSlider.antet")}>
      <CenterWrapper>
        {alerts?.data?.length && (
          <Slider centerMode={false} {...settings}>
            {alerts.data.map((item) => (
              <div key={item.id}>
                <AlertsCarouselItem
                  title={t("components.carouselSlider.antet")}
                  body={item?.attributes?.title}
                  date={item?.attributes?.publishedAt}
                  id={item?.id}
                />
              </div>
            ))}
          </Slider>
        )}
      </CenterWrapper>
    </SliderWrapper>
  );
};

export default CarouselSlider;
